export default [
  {
    path: "/helpList",
    name: "大批量产品采购求助清单",
    component: () => import("../views/helpList/index.vue"),
  },
];
